import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Stack, Divider, Pagination } from '@mui/material';
import Sidebar from '../Layout/SideBar';
import Feedback from '../../models/Feedback';

export default function DashboardFeedback() {
    const [feedbacks, setFeedbacks] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const fetchFeedbacks = async (currentPage) => {
        try {
            const res = await Feedback.getAllFeedback(currentPage, 10);
            setFeedbacks(res.data);
            setTotalPages(res.totalPages || 1);
        } catch (err) {
            throw err;
        }
    };

    useEffect(() => {
        fetchFeedbacks(page);
    }, [page]);

    const getAvatarUrl = (obj) => {
        if (!obj) return `https://ui-avatars.com/api/?name=Anon&background=random`;

        if (obj.avatar) {
            return `${process.env.REACT_APP_STATIC_URL}${obj.avatar}`;
        }
        return `https://ui-avatars.com/api/?name=${encodeURIComponent(obj.username || 'Anon')}&background=random`;
    };

    return (
        <Box display="flex">
            <Sidebar />
            <Box flexGrow={1} p={3}>
                <Typography variant="h5" gutterBottom fontWeight="bold">
                    Tiếp nhận phản hồi
                </Typography>

                {feedbacks.map((fb) => (
                    <Paper
                        key={fb.id}
                        sx={{ p: 2, mb: 2, bgcolor: '#fafafa', border: '1px solid #ddd' }}
                        elevation={1}
                    >
                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={2}
                            justifyContent="space-between"
                            alignItems={{ xs: 'flex-start', sm: 'center' }}
                        >
                            <Stack direction="row" spacing={1} alignItems="center">
                                <img
                                    src={getAvatarUrl(fb)}
                                    alt={fb.username || 'Ẩn danh'}
                                    width={28}
                                    height={28}
                                    style={{ borderRadius: '50%' }}
                                />
                                <Typography variant="subtitle1" fontWeight="bold" color="primary">
                                    {fb.username} - {fb.email}
                                </Typography>
                            </Stack>
                            <Typography variant="caption" color="text.secondary">
                                {new Date(fb.created_at).toLocaleString('vi-VN')}
                            </Typography>
                        </Stack>

                        <Divider sx={{ my: 1 }} />

                        <Box
                            sx={{ mt: 1, color: 'text.primary' }}
                            dangerouslySetInnerHTML={{ __html: fb.content }}
                        />
                    </Paper>
                ))}

                <Box display="flex" justifyContent="center" mt={2}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(e, value) => setPage(value)}
                    />
                </Box>
            </Box>
        </Box>
    );
}
